import { Roles, RolesName } from 'configs/roles';
import { ProfileUserEntity } from 'services/openapi';

export const structure = (initData?: ProfileUserEntity) => [
  {
    name: 'fullName',
    defaultValue: initData?.fullName || '',
    isDisabled: true,
  },
  {
    name: 'phoneNumber',
    defaultValue: initData?.phoneNumber
      ? initData?.phoneNumber?.replace('+84', '0')
      : '',
    isDisabled: true,
  },
  {
    name: 'citizenIdentityCardNo',
    defaultValue: initData?.citizenIdentityCardNo || '',
    isDisabled: true,
  },
  {
    name: 'accountNumber',
    defaultValue: initData?.accountNumber || '',
    isDisabled: true,
  },
  {
    name: 'bidvVaPayerId',
    defaultValue: initData?.bidvVaPayerId || '',
    isDisabled: true,
  },
  // {
  //   name: "role",
  //   defaultValue: initData?.role ? RolesName[String(initData?.role) as keyof typeof RolesName] : "",
  //   isDisabled: true,
  // },
  // {
  //   name: "leaderName",
  //   defaultValue: initData?.leaderName || "",
  //   isDisabled: true,
  // },
  // {
  //   name: "leaderPhoneNumber",
  //   defaultValue: initData?.leaderPhoneNumber ? initData?.leaderPhoneNumber?.replace("+84", "0") : "",
  //   isDisabled: true,
  // },
  // {
  //   name: "agencyName",
  //   defaultValue: initData?.agencyName || "",
  //   isDisabled: true,
  // },
  {
    name: 'compName',
    defaultValue: initData?.compName || '',
    isDisabled: true,
  },
  {
    name: 'status',
    defaultValue: initData?.statusCode || '',
    isDisabled: true,
  },
  {
    name: 'isActive',
    defaultValue: initData?.isActive ? 'Đang hoạt động' : 'Ngưng hoạt động',
    isDisabled: true,
  },
  {
    name: 'email',
    defaultValue: initData?.email || '',
  },
  {
    name: 'myRefferId',
    defaultValue: initData?.myReferrerId || '',
    isDisabled: true,
  },
];
